import { useCallback } from "react";
import { useMerchant } from "@auth";

export function useNavigationFilter() {
  const { hasPermission } = useMerchant();

  const shouldShow = useCallback(
    (navItem) => {
      if (navItem.permission && !hasPermission(navItem.permission)) {
        return false;
      }

      if (navItem.children && navItem.children.length > 0) {
        return navItem.children.some(shouldShow);
      }

      return true;
    },
    [hasPermission],
  );

  const filterNavigation = useCallback(
    (items) => items.filter(shouldShow),
    [shouldShow],
  );

  return { shouldShow, filterNavigation };
}
